/**
 * Temporary listing-profile new UI rollout
 * Allowlisted emails see staging listing profile on /listing-profiles; everyone else sees pre-merge UI.
 * Set LISTING_PROFILE_NEW_UI_ENABLED_FOR_ALL to false to revert to allowlist-only rollout.
 */

/** When true, all users get the new listing profile UI (allowlist ignored). */
export const LISTING_PROFILE_NEW_UI_ENABLED_FOR_ALL = true

export const LISTING_PROFILE_NEW_UI_ALLOWLIST_EMAILS: readonly string[] = [
  'swapana.test3@gmail.com',
  'torsten.mayer@gmail.com',
  'madhariya17@gmail.com',
  'manpreet+temu@constacloud.com',
]

const allowlistSet = new Set(
  LISTING_PROFILE_NEW_UI_ALLOWLIST_EMAILS.map((email) => email.trim().toLowerCase())
)

export const isListingProfileNewUiAllowlisted = (email: string | null | undefined): boolean => {
  if (LISTING_PROFILE_NEW_UI_ENABLED_FOR_ALL) return true
  if (!email) return false
  return allowlistSet.has(email.trim().toLowerCase())
}
